import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./styles.css";
import van from "/public/van_large.webp";

import Partner from "./Partner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { trackComparisonResultView } from "../Leadform/tracking";

const Submission = () => {
  const { uuid } = useParams();
  const [loading, setLoading] = useState(false);
  const [submission, setSubmission] = useState(null);

  useEffect(() => {
    const fetchSubmission = async () => {
      setLoading(true);
      const response = await fetch(
        `/wp-json/wordpress-leadform/v1/submission?uuid=${uuid}`,
      );
      const data = await response.json();
      setSubmission(data);
      setLoading(false);

      // Track comparison result view
      const buyers = data.buyers || [];
      trackComparisonResultView({
        eligibleBuyersCount: data.partners.length,
        highestTrustScore:
          data.partners.length > 0
            ? Math.max(...data.partners.map((b: any) => b.trust_score || 0))
            : 0,
        topBuyerId: data.partners.length > 0 ? data.partners[0].id : "",
      });
    };

    fetchSubmission();
  }, []);

  return (
    <div className="OfferCalculator">
      <div className="Step SubmissionStep">
        {loading ? (
          <div className="Loader">
            <h2>Please wait whilst we fetch your results</h2>
            <div>
              <FontAwesomeIcon className="Spinner" icon={faSpinner} />
            </div>
          </div>
        ) : (
          <>
            <h2>We’ve Found Verified Cash Buyers For Your Property</h2>
            <p>
              Based on the information you provided, we’ve identified buyers
              currently purchasing properties like yours.
            </p>
            <h3>Buyer verification checks</h3>
            <p>
              We've verified all of the buyers so you can choose with complete
              peace of mind.
            </p>
            <ul>
              <li>
                <FontAwesomeIcon icon={faCheck} />
                Proof of funds confirmed
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} />
                Company registration verified
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} />
                Verified purchase history
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} />
                Performance monitoring in place
              </li>
            </ul>
            {submission && (
              <div className="Partners">
                {submission.partners
                  .slice()
                  .sort((a: any, b: any) => {
                    const priorityA =
                      a.priority_override ?? Number.MAX_SAFE_INTEGER;
                    const priorityB =
                      b.priority_override ?? Number.MAX_SAFE_INTEGER;
                    if (priorityA !== priorityB) {
                      return priorityA - priorityB;
                    }
                    const budgetA = a.monthly_lead_budget ?? 0;
                    const budgetB = b.monthly_lead_budget ?? 0;
                    return budgetB - budgetA;
                  })
                  .map((partner: any, index: number) => (
                    <Partner uuid={uuid} key={index} partner={partner} />
                  ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Submission;
